//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import MetroLinesData from '@/data/metro_lines'
import ZonesCheckbox from './_zones_checkbox'

export default {
    components: {
        ZonesCheckbox
    },
    data () {
        const tabs = [
            {
                text: '城区',
                value: 'zone'
            },
            {
                text: '地铁',
                value: 'metro'
            }
        ]
        if (this.show_ring_road) {
            tabs.push({
                text: '环线',
                value: 'ring_road'
            })
        }
        if (this.show_nearby) {
            tabs.push({
                text: '附近',
                value: 'nearby'
            })
        }
        return {
            type: 'zone',
            tabs,
            selected_zone: '',
            metros: [],
            zones: [],
            sections: [],
            checkbox_selected: [],
            checkbox_selected_tx: [],
            level_zones: null,
            miles: [
                {
                    value: 1000,
                    text: '1公里',
                    selected: false
                },
                {
                    value: 2000,
                    text: '2公里',
                    selected: false
                },
                {
                    value: 3000,
                    text: '3公里',
                    selected: false
                }
            ],
            ring_roads: [
                    {
                        value: '',
                        text: '不限',
                        selected: false
                    },
                    {
                        value: '一环内',
                        text: '一环内',
                        selected: false
                    },
                    {
                        value: '一环-二环',
                        text: '一环-二环',
                        selected: false
                    },
                    {
                        value: '二环-三环',
                        text: '二环-三环',
                        selected: false
                    },
                    {
                        value: '三环-绕城',
                        text: '三环-绕城',
                        selected: false
                    },
                    {
                        value: '绕城外',
                        text: '绕城外',
                        selected: false
                    }
            ]
        }
    },
    computed: {
        selected_all_zone () {
            return this.zones.every(({ selected }) => {
                return selected
            }) || this.zones.every(({ selected }) => {
                return !selected
            })
        },
        selected_all_section () {
            return this.sections.every(({ selected }) => {
                return selected
            }) || this.sections.every(({ selected }) => {
                return !selected
            })
        },
        zone_opts_classname () {
            return this.sections.length > 0 ? 'opts1' : 'opts2'
        }
    },
    watch: {
        current_address (latest) {
            if (latest && this.miles.every(({ selected }) => !selected)) {
                this.miles[this.miles.length - 1].selected = true
            }
        }
    },
    mounted () {
        this.getData()
    },
    destroyed () {
        this.reset()
    },
    methods: {
        onSettingAddress () {
            if (this.current_address) {
                wx.navigateTo({
                    url: `/pages/packageA/choose_location/main?latitude=${this.latitude}&longitude=${this.longitude}&current_address=${this.current_address}`
                })
            }
        },
        changeType (type) {
            this.reset()
            this.type = type
            if (type === 'nearby') {
                this.$emit('getLocation')
            }
        },
        async getData () {
            const data = await Service.getZones()
            const { level1 = [], level2 = [], level3 = [], others = [] } = data
            this.level_zones = data
            this.zones = level1.concat(level2).concat(level3).concat(others)
            const lines = await MetroLinesData.getMetroLines()
            this.metros = lines.map((line) => {
                return {
                    name: line,
                    value: parseInt(line),
                    selected: false
                }
            })
        },
        selectAll () {
            this.selected_zone = ''
            this.zones.forEach((zone) => {
                zone.selected = false
            })
            this.sections = []
        },
        onSelect (e) {
            const { index } = e.currentTarget.dataset
            const { id, sections } = this.zones[index]
            this.selected_zone = id
            this.sections = sections.map((item) => {
                return {
                    ...item,
                    selected: false
                }
            })
        },
        onSelectMile (index) {
            if (!this.current_address) {
                return
            }
            this.miles.forEach((item, i) => {
                item.selected = index === i
            })
        },
        onSelectRingRoad (index) {
            this.ring_roads.forEach((item, i) => {
                item.selected = index === i
            })
        },
        onSelectCheckbox (selected, selected_tx) {
            this.checkbox_selected = selected
            this.checkbox_selected_tx = selected_tx
        },
        onSelectSection (e) {
            const { index } = e.currentTarget.dataset
            const item = this.sections[index]
            this.$set(this.sections, index, {
                ...item,
                selected: !item.selected
            })
        },
        selectAllSection () {
            this.sections.forEach((item, index) => {
                this.$set(this.sections, index, {
                    ...item,
                    selected: false
                })
            })
        },
        onSelectMetro (selected_index) {
            const metro = this.metros[selected_index]
            this.$set(this.metros, selected_index, {
                ...metro,
                selected: !metro.selected
            })
        },
        reset () {
            this.selected_zone = ''
            this.onSelectCheckbox([], [])
            this.zones.forEach((zone) => {
                zone.selected = false
            })
            this.sections.forEach((item, i) => {
                this.$set(this.sections, i, {
                    ...item,
                    selected: false
                })
            })
            this.metros.forEach((item, i) => {
                this.$set(this.metros, i, {
                    ...item,
                    selected: false
                })
            })
            this.ring_roads.forEach((item, i) => {
                item.selected = false
            })
            this.miles.forEach((item, i) => {
                item.selected = false
            })
        },
        confirm () {
            let emit_opts = {}
            if (this.show_section) {
                let selected_tx
                if (this.selected_zone) {
                    this.zones.some(({ id, name }) => {
                        if (id === this.selected_zone) {
                            selected_tx = name
                            return true
                        }
                    })
                    this.sections.forEach(({ name, selected }) => {
                        if (selected) {
                            selected_tx += `,${name}`
                        }
                    })
                }
                const selected_section = this.sections.filter(({ selected }) => selected).map(({ id }) => id)
                emit_opts = {
                    zone_ids: this.selected_zone,
                    text: selected_tx || '不限',
                    zone_section_ids: selected_section.join(',')
                }
            } else {
                emit_opts = {
                    zone_ids: this.checkbox_selected.join(','),
                    text: this.checkbox_selected_tx,
                    zone_section_ids: ''
                }
            }
            emit_opts.metro = this.metros
                .filter(({ selected, value }) => selected && value)
                .map(({ value }) => `${value}号线`)
                .join(',')
            this.miles.some((item) => {
                if (item.selected) {
                    emit_opts.nearby = item
                    emit_opts.location = `${this.longitude},${this.latitude}`
                    emit_opts.current_address = this.current_address
                    return true
                }
            })
            this.ring_roads.some((item) => {
                if (item.selected) {
                    emit_opts.ring_road = item
                    return true
                }
            })
            this.$emit('changeZone', emit_opts)
        }
    },
    props: {
        zone_ids: {
            type: String
        },
        show_section: {
            type: Boolean,
            default: false
        },
        show_nearby: Boolean,
        latitude: [String, Number],
        longitude: [String, Number],
        current_address: String,
        show_ring_road: Boolean
    }
}
